import React from "react";
import { Box, IconButton, Button } from "@mui/material";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
const CustomPaginationCommon = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: any) => {
  const totalPages = Math.ceil(count / rowsPerPage);


  const startPage = Math.max(0, Math.min(page - 2, totalPages - 5));
  const endPage = Math.min(totalPages, startPage + 5);

  const handlePageChange = (event: any, newPage: number) => {
    onPageChange(event, newPage); // Use zero-based index for internal logic
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" mt={2}>
      <Box bgcolor={"#F4F4F4"} p={1} sx={{ borderRadius: "30px" }}>
        <IconButton
          onClick={(event) => handlePageChange(event, page - 1)}
          disabled={page === 0}
        >
          <KeyboardDoubleArrowLeftIcon sx={{ color: "#233F91" }} />
        </IconButton>
        {Array.from({ length: endPage - startPage }, (_, index) => {
          const pageIndex = startPage + index;
          return (
            <Button
              key={pageIndex}
              onClick={(event) => handlePageChange(event, pageIndex)}
              sx={{
                bgcolor: pageIndex === page ? "white" : "#F4F4F4",
                color: pageIndex === page ? "#233F91" : "#233F91",
                boxShadow: pageIndex === page ? 3 : "none",
                borderRadius: "50%",
                width: 51,
                height: 51,
                minWidth: 0,
                padding: 0,
                mx: 0.5,
              }}
            >
              {pageIndex + 1}
            </Button>
          );
        })}
        <IconButton
          onClick={(event) => handlePageChange(event, page + 1)}
          disabled={page >= totalPages - 1}
        >
          <KeyboardDoubleArrowRightIcon sx={{ color: "#233F91" }} />
        </IconButton>
      </Box>
    </Box>
  );
};
export default CustomPaginationCommon;
